import { combineReducers } from 'redux'

import list from './list/slice'

const tariffsReducer = combineReducers({
  list,
})

export default tariffsReducer
